var _regeneratorRuntime = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator");

var _classCallCheck = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _possibleConstructorReturn = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _assertThisInitialized = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/assertThisInitialized");

var _inherits = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");

var _toConsumableArray = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/toConsumableArray");

var _require = require('crypto'),
    generateKeyPairSync = _require.generateKeyPairSync,
    async = _require.generateKeyPair;

var _require2 = require('util'),
    promisify = _require2.promisify;

var _require3 = require('../../help/consts'),
    THUMBPRINT_MATERIAL = _require3.THUMBPRINT_MATERIAL,
    JWK_MEMBERS = _require3.JWK_MEMBERS,
    PUBLIC_MEMBERS = _require3.PUBLIC_MEMBERS,
    PRIVATE_MEMBERS = _require3.PRIVATE_MEMBERS,
    KEY_MANAGEMENT_DECRYPT = _require3.KEY_MANAGEMENT_DECRYPT,
    KEY_MANAGEMENT_ENCRYPT = _require3.KEY_MANAGEMENT_ENCRYPT;

var _require4 = require('../../help/runtime_support'),
    keyObjectSupported = _require4.keyObjectSupported;

var _require5 = require('../../help/key_object'),
    createPublicKey = _require5.createPublicKey,
    createPrivateKey = _require5.createPrivateKey;

var Key = require('./base');

var generateKeyPair = promisify(async);
var RSA_PUBLIC = new Set(['e', 'n']);
Object.freeze(RSA_PUBLIC);
var RSA_PRIVATE = new Set([].concat(_toConsumableArray(RSA_PUBLIC), ['d', 'p', 'q', 'dp', 'dq', 'qi']));
Object.freeze(RSA_PRIVATE); // RSA Key Type

var RSAKey =
/*#__PURE__*/
function (_Key) {
  "use strict";

  _inherits(RSAKey, _Key);

  function RSAKey() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, RSAKey);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(RSAKey)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this[JWK_MEMBERS]();

    Object.defineProperties(_assertThisInitialized(_this), {
      kty: {
        value: 'RSA',
        enumerable: true
      },
      length: {
        get: function get() {
          Object.defineProperty(this, 'length', {
            value: Buffer.byteLength(this.n, 'base64') * 8,
            configurable: false
          });
          return this.length;
        },
        configurable: true
      }
    });
    return _this;
  }

  _createClass(RSAKey, [{
    key: THUMBPRINT_MATERIAL,
    // https://tc39.github.io/ecma262/#sec-ordinaryownpropertykeys no need for any special
    // JSON.stringify handling in V8
    value: function value() {
      return {
        e: this.e,
        kty: 'RSA',
        n: this.n
      };
    }
  }, {
    key: KEY_MANAGEMENT_ENCRYPT,
    value: function value() {
      return this.algorithms('wrapKey');
    }
  }, {
    key: KEY_MANAGEMENT_DECRYPT,
    value: function value() {
      return this.algorithms('unwrapKey');
    }
  }], [{
    key: "generate",
    value: function generate() {
      var len,
          privat,
          privateKey,
          publicKey,
          _ref,
          _ref2,
          _args = arguments;

      return _regeneratorRuntime.async(function generate$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              len = _args.length > 0 && _args[0] !== undefined ? _args[0] : 2048;
              privat = _args.length > 1 && _args[1] !== undefined ? _args[1] : true;

              if (!(!Number.isSafeInteger(len) || len < 512 || len % 8 !== 0 || 'electron' in process.versions && len % 128 !== 0)) {
                _context.next = 4;
                break;
              }

              throw new TypeError('invalid bit length');

            case 4:
              if (!keyObjectSupported) {
                _context.next = 11;
                break;
              }

              _context.next = 7;
              return _regeneratorRuntime.awrap(generateKeyPair('rsa', {
                modulusLength: len
              }));

            case 7:
              _ref = _context.sent;
              privateKey = _ref.privateKey;
              publicKey = _ref.publicKey;
              return _context.abrupt("return", privat ? privateKey : publicKey);

            case 11:
              _context.next = 13;
              return _regeneratorRuntime.awrap(generateKeyPair('rsa', {
                modulusLength: len,
                publicKeyEncoding: {
                  type: 'spki',
                  format: 'pem'
                },
                privateKeyEncoding: {
                  type: 'pkcs8',
                  format: 'pem'
                }
              }));

            case 13:
              _ref2 = _context.sent;
              privateKey = _ref2.privateKey;
              publicKey = _ref2.publicKey;

              if (!privat) {
                _context.next = 20;
                break;
              }

              return _context.abrupt("return", createPrivateKey(privateKey));

            case 20:
              return _context.abrupt("return", createPublicKey(publicKey));

            case 21:
            case "end":
              return _context.stop();
          }
        }
      });
    }
  }, {
    key: "generateSync",
    value: function generateSync() {
      var len = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 2048;
      var privat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      if (!Number.isSafeInteger(len) || len < 512 || len % 8 !== 0 || 'electron' in process.versions && len % 128 !== 0) {
        throw new TypeError('invalid bit length');
      }

      var privateKey, publicKey;

      if (keyObjectSupported) {
        var _generateKeyPairSync = generateKeyPairSync('rsa', {
          modulusLength: len
        });

        privateKey = _generateKeyPairSync.privateKey;
        publicKey = _generateKeyPairSync.publicKey;
        return privat ? privateKey : publicKey;
      }

      var _generateKeyPairSync2 = generateKeyPairSync('rsa', {
        modulusLength: len,
        publicKeyEncoding: {
          type: 'spki',
          format: 'pem'
        },
        privateKeyEncoding: {
          type: 'pkcs8',
          format: 'pem'
        }
      });

      privateKey = _generateKeyPairSync2.privateKey;
      publicKey = _generateKeyPairSync2.publicKey;

      if (privat) {
        return createPrivateKey(privateKey);
      } else {
        return createPublicKey(publicKey);
      }
    }
  }, {
    key: PUBLIC_MEMBERS,
    get: function get() {
      return RSA_PUBLIC;
    }
  }, {
    key: PRIVATE_MEMBERS,
    get: function get() {
      return RSA_PRIVATE;
    }
  }]);

  return RSAKey;
}(Key);

module.exports = RSAKey;